import React, { useContext, useState, useEffect } from "react";
import { Button, TextField } from "@mui/material/";
import { tss } from "tss-react/mui";
import { formatDate } from "services/UtilsService";
import { getCachedData } from "api/Cache";
import { ViewsActions } from "actions";
import ViewerEvents from "events/ViewerEvents";
import ConfirmationDialog from "components/ConfirmationDialog";
import { Scrollbars } from "react-custom-scrollbars";
import { defaultThumbnailIcon } from "constants/common";
import { getAccessLevel, handleClick } from "actions/ViewerTools";
import { useHistory } from "react-router-dom";
import { Person, DateRange, Update, FolderOpen } from "@mui/icons-material";
import commonStyles from "styles/common";
import {ViewContext} from "panels/LeftPanel";
import {  useDispatch, useSelector } from 'react-redux';
import { setData } from "store/main/viewerHistory";
import { alpha } from '@mui/material/styles';

const useStyles = tss.create(({theme}) => ({
    root: {
        textAlign: "center",
        position: "relative",
        paddingTop: 24,
        height: "calc(100vh - 120px)",
        color: theme.palette.text.primary,
        background: alpha(theme.palette.background.default, 0.85)
    },
    description: {
        display: "inline-flex",
        fontSize: 14,
        textAlign: "left",
        width: 280,
        color: theme.palette.text.secondary, //"#434343",
        height: 60,
        marginBottom: 10,
    },
    tags: {
        height: 40,
    },
    media: {
        display: "inline-block",
        width: 280,
        height: 280,
    },
    info: {
        position: "relative",
        top: 26,
        width: 280,
        textAlign: "center",
    },
    table: {
        width: 280,
        marginLeft: 9,
    },
    firstColumn: {
        textAlign: "left",
        color: theme.palette.text.disabled, //"rgba(0,0,0,0.55)",
        width: 110,
    },
    secondColumn: {
        textAlign: "left",
        color: theme.palette.text.secondary, //"#434343",
    },
    icon: {
        display: "inline-block",
        width: 16,
        height: 16,
        color: theme.palette.text.disabled, //"#AAAAAA",
        position: "relative",
        top: 3,
    },
    buttonsContainer: {
        textAlign: "center",
        display: "block",
        position: "relative",
        top: 50,
    },
    button: {
        width: 167,
        marginBottom: 24,
    },
    name: {
        height: 22,
        width: 254,
        color: theme.palette.primary.main, //"#0075B0",
        fontSize: 20,
        letterSpacing: "0.15px",
    },
    changeThumbnail: {
        position: "absolute",
        top: 120,
        left: 50,
        width: 204,
        height: 36,
        border: "1px solid #F4F4F4",
        borderRadius: 4,
        color: "#FFFFFF",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: "1.17px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "transparent",
    },
    textField: {
        width: 280,
        height: 40,
    },
    defaultThumb: {
        backgroundColor: "rgb(100,100,100)",
        width: 280,
        height: 280,
        position: "relative",
        left: 10,
    },
    hide: {
        display: "none",
    },
}));

type ISettingsProps = {
    view: any;
    newScene: boolean;
    updateParent: () => void;
};

export default function SettingsPanel(props: ISettingsProps) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { newScene } = props;
    const history = useHistory();
    const [update, setUpdate] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const view = getCachedData("views")[props.view.ID];
    const pending = getCachedData("pending");
	/*const storeCachedData = useSelector((state: any) => state.cache);
    const { views } = storeCachedData.data;
    const view = JSON.parse(JSON.stringify(views[props.view.ID]));*/
    const [thumb, setThumb] = useState(defaultThumbnailIcon);
    const dispatch = useDispatch();

    const newView: any = Boolean(
        Object.values(pending).find((object: any) => object.action === "add" && object.ID === props.view.ID)
    ); 
    const { 
        hasFullAccess,
        isDefaultProject,
        sweetAlerts
    } = useContext<any>(ViewContext);

    useEffect(() => {
        thumb !== view?.thumb && setThumb(view?.thumb || defaultThumbnailIcon)
    }, [thumb, view?.thumb, defaultThumbnailIcon])
    
    
    if (!view) {
        return <div />;
    }
    let project = getCachedData("projects")[view.project];
    const access_level = getAccessLevel(view.project) || "read";
    if (!project) {
        project = { name: "", access_level: "read" };
    }

    const shareView = () => {};
    const duplicateView = () => {
        ViewsActions.duplicateView(view, (id: string) => {
            history.push("/views");
            history.push("/views/" + id);
            history.goForward();
        });
    };

    const confirmAction = (object: any) => {
        if (object.status) {
            ViewsActions.deleteView(view, () => {
                setOpenConfirmation(false);
                ViewerEvents.emit("destroyView", {});
                history.push("/views/");
                history.goForward();
            });
        } else {
            setOpenConfirmation(false);
        }
    };

    const confirmDeleteView = () => {
        setOpenConfirmation(true);
    };

    const changeThumbail = (evt: any) => {
        if (isDefaultProject || !hasFullAccess) {
            sweetAlerts();
            return;
        }
        handleClick({ cmd: "changeThumbnail" }, (view) => {
            const _view = JSON.parse(JSON.stringify(view));
            view && dispatch(setData({ view: _view }));
            setUpdate(!update);
        });
    };

    const editName = (evt: any) => {
        if (isDefaultProject || !hasFullAccess) {
            sweetAlerts();
            return;
        }
        view.name = evt.target.value;
        const _view = JSON.parse(JSON.stringify(view));
        view && dispatch(setData({ view: _view }));
        setUpdate(!update);
        props.updateParent();
    };

    const editDescription = (evt: any) => {
        if (isDefaultProject || !hasFullAccess) {
            sweetAlerts();
            return;
        }
        view.description = evt.target.value;
        const _view = JSON.parse(JSON.stringify(view));
        view && dispatch(setData({ view: _view }));
        setUpdate(!update);
        props.updateParent();
    };

    return (
        <div className={classes.root} style={{ userSelect: update ? "none" : "none" }}>
            <Scrollbars style={{ overflowX: "hidden" }}>
                <div className={cx(common.middleCenter, classes.description)}>
                    <TextField
                        id="new-view-name"
                        label="View Name"
                        className={classes.textField}
                        defaultValue={view?.name || ''}
                        onChange={editName}
                        disabled={isDefaultProject || !hasFullAccess}
                        sx={{
                            '& .MuiInputBase-input': {
                                padding: "8px 14px",
                            }
                        }}
                    />
                </div>
                <div className={classes.description}>
                    <TextField
                        id="new-view-description"
                        label="Description"
                        className={classes.textField}
                        defaultValue={view?.description || ''}
                        onChange={editDescription}
                        inputProps={{ "aria-label": "Description" }}
                        disabled={isDefaultProject || !hasFullAccess}
                    />
                </div>
                <div className={classes.tags} style={{ display: "none" }}></div>
                <div style={{ position: "relative" }}>
                    <div className={!thumb || thumb === defaultThumbnailIcon ? classes.defaultThumb : ""}>
                        <img
                            alt="view slide"
                            className={
                                !thumb || thumb === defaultThumbnailIcon ? classes.hide : classes.media
                            }
                            src={thumb}
                        />
                    </div>
                    <Button
                        onClick={changeThumbail}
                        color="primary"
                        aria-label="Set Thumbnail"
                        title="Set Thumbnail"
                        className={classes.changeThumbnail}
                        disabled={!newScene}
                    >
                        SET THUMBNAIL
                    </Button>
                </div>
                <div className={classes.info}>
                    <table className={classes.table}>
                        <tbody>
                            <tr>
                                <td className={classes.firstColumn}>
                                    <Person className={classes.icon} /> Created by
                                </td>
                                <td className={classes.secondColumn}></td>
                            </tr>
                            <tr>
                                <td className={classes.firstColumn}>
                                    <DateRange className={classes.icon} /> Created on
                                </td>
                                <td className={classes.secondColumn}>
                                    {view.file_date ? formatDate(view.file_date) : ""}
                                </td>
                            </tr>
                            <tr>
                                <td className={classes.firstColumn}>
                                    <Update className={classes.icon} /> Updated on
                                </td>
                                <td className={classes.secondColumn}>
                                    {view.file_date ? formatDate(view.file_date) : ""}
                                </td>
                            </tr>
                            <tr>
                                <td className={classes.firstColumn}>
                                    <FolderOpen className={classes.icon} /> Project
                                </td>
                                <td className={classes.secondColumn}>{project.name}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className={classes.buttonsContainer}>
                    <Button
                        onClick={(e) => {
                            if (isDefaultProject || !hasFullAccess) {
                                sweetAlerts();
                                return;
                            }
                            shareView();
                        }}
                        color="primary"
                        aria-label="SHARE View"
                        title="SHARE VIEW"
                        className={classes.button}
                        disabled={true}
                    >
                        SHARE VIEW
                    </Button>
                    <Button
                        onClick={(e) => {
                            if (isDefaultProject || !hasFullAccess) {
                                sweetAlerts();
                                return;
                            }
                            duplicateView();
                        }}
                        color="primary"
                        aria-label="DUPLICATE View"
                        title="DUPLICATE VIEW"
                        className={classes.button}
                        disabled={(access_level !== "write" && access_level !== "full") || newView}
                    >
                        DUPLICATE VIEW
                    </Button>
                    <Button
                        onClick={(e) => {
                            if (isDefaultProject || !hasFullAccess) {
                                sweetAlerts();
                                return;
                            }
                            confirmDeleteView();
                        }}
                        color="primary"
                        aria-label="DELETE View"
                        title="DELETE VIEW"
                        className={classes.button}
                        disabled={(access_level !== "write" && access_level !== "full") || newView}
                    >
                        DELETE VIEW
                    </Button>
                </div>
            </Scrollbars>
            {openConfirmation ? (
                <ConfirmationDialog
                    open={openConfirmation}
                    title="Delete View"
                    type="view"
                    name={view.name}
                    confirmAction={confirmAction}
                />
            ) : (
                ""
            )}
        </div>
    );
}
